import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ArchiveFileBoxIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1664 2.66699C14.1664 2.57505 14.0922 2.50018 14.0003 2.5H2.00034C1.90829 2.5 1.83334 2.57494 1.83334 2.66699V4.66699C1.83352 4.75889 1.9084 4.83301 2.00034 4.83301H14.0003C14.0921 4.83283 14.1662 4.75878 14.1664 4.66699V2.66699ZM15.1664 4.66699C15.1662 5.31107 14.6444 5.83283 14.0003 5.83301H2.00034C1.35611 5.83301 0.833519 5.31117 0.833344 4.66699V2.66699C0.833344 2.02266 1.356 1.5 2.00034 1.5H14.0003C14.6445 1.50018 15.1664 2.02277 15.1664 2.66699V4.66699Z"
      fill="currentColor"
    />
    <path
      d="M2.16666 12.6663V5.33333C2.16666 5.05719 2.39051 4.83333 2.66666 4.83333C2.9428 4.83333 3.16666 5.05719 3.16666 5.33333V12.6663C3.16666 12.8874 3.25452 13.0999 3.4108 13.2562C3.56699 13.4123 3.77884 13.5002 3.99966 13.5003H11.9997C12.2207 13.5003 12.4332 13.4125 12.5895 13.2562C12.7458 13.0999 12.8336 12.8874 12.8336 12.6663V5.33333C12.8336 5.05719 13.0575 4.83333 13.3336 4.83333C13.6096 4.8335 13.8336 5.05729 13.8336 5.33333V12.6663C13.8336 13.1526 13.6404 13.6194 13.2965 13.9632C12.9527 14.307 12.4859 14.5003 11.9997 14.5003H3.99966C3.51363 14.5002 3.04749 14.3068 2.70377 13.9632C2.35995 13.6194 2.16666 13.1526 2.16666 12.6663Z"
      fill="currentColor"
    />
    <path
      d="M9.33365 7.5C9.60964 7.50018 9.83365 7.72397 9.83365 8C9.83365 8.27603 9.60964 8.49982 9.33365 8.5H6.66666C6.39051 8.5 6.16666 8.27614 6.16666 8C6.16666 7.72386 6.39051 7.5 6.66666 7.5H9.33365Z"
      fill="currentColor"
    />
  </svg>
);
